import { Box } from "@mui/material";
import { Button } from "@vds/buttons";
import { Tabs, Tab } from "@vds/tabs";
import "./assets.css";
import MapView from "./common/MapView";
import FloorView from "./common/FloorView";
import DeleteAssetModal from "./DeleteAssetModel";
import {
  fetchRequest,
  updateUI,
  deleteRequest,
  fetchDeviceTypesRequest,
  fetchDeviceNamesRequest,
  fetchLocationsRequest,
  fetchDeviceDetailsRequest,
  updateFilters,
  floorViewRequest,
} from "../../store/actions/asset";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ToastNotification from "../../global/components/ToastNotification";
import FormAsset from "./form/index";
import { mapDataTabIndex } from "../../store/actions/singleAsset";

function Assets() {
  const {
    isRefresh,
    isDeleteOpen,
    isFormOpen,
    selectedAsset,
    notification,
    formdata,
    opType,
    isFloorView,
    user,
    uniqueLocations,
    selectedLocation,
    filters
  } = useSelector((state) => ({
    isRefresh: state.asset.isRefresh,
    isDeleteOpen: state.asset.ui.opType === "delete" ? true : false,
    isFormOpen:
      state.asset.ui.opType === "create" ||
      state.asset.ui.opType === "edit" ||
      state.asset.ui.opType === "clone" ||
      state.asset.ui.opType === "selectProfile"
        ? true
        : false,
    selectedAsset: state.asset.ui.selectedAsset,
    notification: state.asset.ui.notification,
    formdata: state.asset.ui.formData,
    opType: state.asset.ui.opType,
    isFloorView: state.asset.ui.isFloorView,
    user: state.auth.user,
    uniqueLocations: state.asset.data.uniqueLocations || [],
    selectedLocation: state.asset.ui.selectedLocation || null,
    filters: state.asset.filters
  }));
  
  const dispatch = useDispatch();

  useEffect(() => {
    // const lastPathname = sessionStorage.getItem("currentPathname");

    // const pattern = /^\/assets\/.+$/;
    // if ((lastPathname !== "/assets") && !pattern.test(lastPathname)) {
    //   dispatch(clearFilter());
    // }

    dispatch(fetchRequest());
    dispatch(fetchLocationsRequest());
    dispatch(fetchDeviceDetailsRequest());
    dispatch(mapDataTabIndex(0));
  }, [dispatch, isRefresh, user?.accountId]);

  useEffect(() => {
    const lastPathname = sessionStorage.getItem("currentPathname");
    const uuidPattern = /^\/assets\/[0-9a-z-]+$/;

    if (isFloorView && uuidPattern.test(lastPathname)) {
      let selectedLoc =  null;
      if( selectedLocation?.id){
       selectedLoc = uniqueLocations.find(
        (location) => location.id === selectedLocation.id
      );
    }else{
      const locName = filters?.locationzone?.option?.split(" - ")?.[0]
       selectedLoc = uniqueLocations.find(
        (location) => location.name === locName
      );
    }

      dispatch(
        floorViewRequest({
          location: selectedLoc,
          floorIndex: 0,
        })
      );
      dispatch(
        updateUI({
          floorView: {
            height: "450px",
            scale: 1.25,
            isDragging: false,
            translateX: 0,
            translateY: 0,
            selectedIndex: 0,
          },
          selectedLocation: null,
        })
      );
    }
  }, [dispatch, isFloorView, selectedLocation?.id]);

  useEffect(() => {
    let timer1 = null;
    if (notification?.isActive) {
      timer1 = setTimeout(() => {
        dispatch(updateUI({ notification: { isActive: false } }));
      }, 2000);
    }
    return () => {
      clearTimeout(timer1);
    };
  }, [dispatch, notification?.isActive, user?.accountId]);

  const handleAddAsset = () => {
    dispatch(fetchDeviceTypesRequest());
    dispatch(fetchDeviceNamesRequest());
    dispatch(
      updateUI({
        selectedAsset: { opHeaderText: "Add" },
        opType: "create",
        formData: {
          selectedStep: 1,
          step1: {
            errors: {
              assetName: false,
            },
            assetName: "",
            description: "",
          },
          step2: {
            errors: {
              deviceType: false,
              deviceId: false,
              deviceProfile: false,
            },
            deviceTypes: [],
            deviceNames: [],
            deviceProfiles: [],
            deviceType: "",
            deviceId: "",
            deviceProfile: "",
          },
          step3: {
            zone: "",
            assetType: "",
            assetModel: "",
            assetSerialNumber: "",
            assetOwner: "",
          },
        },
      })
    );
  };

  const onExit = () => {
    dispatch(
      updateUI({
        selectedAsset:
          opType === "selectProfile"
            ? {
                opType: selectedAsset?.opType,
                opHeaderText: selectedAsset?.opHeaderText,
              }
            : null,
        opType: opType === "selectProfile" ? selectedAsset?.opType : null,
        formData: {
          selectedStep: 1,
          step1: {
            errors: {
              assetName: false,
            },
            assetName: "",
            description: "",
          },
          step2: {
            errors: {
              deviceType: false,
              deviceId: false,
              deviceProfile: false,
            },
            deviceTypes: [],
            deviceNames: [],
            deviceProfiles: [],
            deviceType: "",
            deviceId: "",
            deviceProfile: "",
          },
          step3: {
            zone: "",
            assetType: "",
            assetModel: "",
            assetSerialNumber: "",
            assetOwner: "",
          },
        },
      })
    );
  };

  return (
    <div
      style={{
        minHeight: "75vh",
        margin: "0 auto",
        display: "row",
        flexDirection: "column",
      }}
    >
      {notification.isActive && (
        <ToastNotification
          type={notification.type}
          message={notification.message}
          description={notification.description}
          duration={1}
          style={notification.style}
        />
      )}
      <Box sx={{ p: 0, width: "100%" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h2 className="page-common-heading_tittle">Assets</h2>
          <div style={{ alignContent: "end" }}>
            <Button
              style={{
                marginTop: "-42px",
                fontFamily: "VerizonNHGDS",
                fontWeight: 700,
                fontSize: "16px",
                lineHeight: "20px",
                letterSpacing: "0.5px",
                textAlign: "center",
              }}
              size="large"
              use="primary"
              onClick={handleAddAsset}
            >
              Add asset
            </Button>
          </div>
        </div>
      </Box>
      <Box sx={{ p: 0, width: "100%" }} className="ats-assets">
        <Tabs
          orientation="horizontal"
          indicatorPosition="bottom"
          width={"100px"}
          onTabChange={(_, index) => {
            if (index === 0) {
              dispatch(updateUI({ isFloorView: false }));
              dispatch(
                updateFilters({
                  isRefresh: undefined,
                  filters: {
                    assetstatus: {
                      sort: "",
                      option: [
                        {
                          text: "No Alert",
                          value: false,
                        },
                        {
                          text: "Warning",
                          value: false,
                        },
                        {
                          text: "Critical",
                          value: false,
                        },
                        {
                          text: "Notification",
                          value: false,
                        },
                      ],
                    },
                    assetname: {
                      sort: "asc",
                      option: "",
                    },
                    assetid: {
                      sort: "asc",
                      option: "",
                    },
                    devicename: {
                      sort: "asc",
                      option: "",
                    },
                    location: {
                      sort: "asc",
                      option: "",
                    },
                    locationzone: { sort: "asc", option: "" },
                    updatedat: {
                      sort: "asc",
                      option: {
                        lastupdatedfrom: "",
                        lastupdatedto: "",
                      },
                    },
                  },
                  sort: {
                    field: "createdon",
                    order: "desc",
                  },
                })
              );
              return;
            }

            dispatch(
              updateUI({
                isFloorView: index === 1,
              })
            );

             dispatch(
              floorViewRequest({
                location:  Array.isArray(uniqueLocations) && uniqueLocations?.length > 0
                    ? uniqueLocations[0]
                    : null,
                floorIndex: 0,
              })
            );

            dispatch(
              updateFilters({
                isRefresh: undefined,
                filters: {
                  assetstatus: {
                    sort: "",
                    option: [
                      {
                        text: "No Alert",
                        value: false,
                      },
                      {
                        text: "Warning",
                        value: false,
                      },
                      {
                        text: "Critical",
                        value: false,
                      },
                      {
                        text: "Notification",
                        value: false,
                      },
                    ],
                  },
                  assetname: {
                    sort: "asc",
                    option: "",
                  },
                  assetid: {
                    sort: "asc",
                    option: "",
                  },
                  devicename: {
                    sort: "asc",
                    option: "",
                  },
                  location: {
                    sort: "asc",
                    option: "",
                  },
                  //locationzone: { sort: "asc", option: "" },
                  locationzone: {
                    sort: "asc",
                    option: Array.isArray(uniqueLocations) && uniqueLocations?.length > 0 ? `${uniqueLocations?.[0]?.name} - ${
                      uniqueLocations?.[0]?.floors?.[0]?.name}` : "",
                  },
                  updatedat: {
                    sort: "asc",
                    option: {
                      lastupdatedfrom: "",
                      lastupdatedto: "",
                    },
                  },
                },
                sort: {
                  field: "createdon",
                  order: "desc",
                },
              })
            );
          }}
          selectedIndex={isFloorView ? 1 : 0}
        >
          <Tab label="Map View">
            <MapView />
          </Tab>
          <Tab label="Floor View">
            <FloorView />
          </Tab>
        </Tabs>
      </Box>
      <FormAsset
        opHeaderText={selectedAsset?.opHeaderText}
        formData={formdata}
        open={isFormOpen}
        onConfirm={() => {}}
        onExit={() => {
          onExit();
        }}
      />
      <DeleteAssetModal
        message={selectedAsset?.name}
        onConfirm={() => {
          dispatch(deleteRequest());
        }}
        onExit={() => {
          onExit();
        }}
        open={isDeleteOpen}
      />
    </div>
  );
}

export default Assets;
